import { IonContent, IonInput, IonIcon, IonPage, IonText, IonSpinner } from "@ionic/react";
import moment from "moment";
import Select from "react-select"
import { useEffect, useState, useMemo } from "react";
import { useHistory, useLocation } from "react-router";
import { Modal } from "react-bootstrap";
import DataTable from "react-data-table-component";
import service from "../../Service/service";
import Head from "../Header";
import Sidebar from "../Sidebar";
import swal from 'sweetalert';
import { searchOutline, chevronDownOutline } from "ionicons/icons";
const ProjectClosureView: React.FC = (props) => {

    const history = useHistory();
    const location: any = useLocation();
    const [createdBy] = useState(localStorage.getItem("SignupEmpId"));
    const [data, setdata] = useState([])
    const [activitydata, setactivitydata] = useState([])
    const [statusList, setStatusList] = useState([]);
    const [token] = useState(localStorage.getItem("SignupEmpId"));


    const [prjresource, setprjresource] = useState<number>(0); // Set the initial value as a number
    const [activity, setactivity] = useState<number>(0);

    const [projectStatusId, setProjectStatusId] = useState('')
    const [remarks, setRemarks] = useState('')
    const projectId = location.state?.projectId;
    const projectName = location.state?.projectName;

    const Id = (location.state?.id);


    useEffect(() => {

        if (token === null) {
            history.push("/login");
        } else {
        }
    }, [token, history]);

    useEffect(() => {
        GetStatusList();
    }, [])



    //--------------get Status list----------------------//
    const hanldeStatusType = (e: any) => {
        setProjectStatusId(e.target.value)
    }


    const GetStatusList = () => {
        service.GetPrjClsStatuslist()
            .then((response) => {
                console.log(response);
                if (response.status === 200) {
                    setStatusList(response.data);
                }
                else {
                    setStatusList([])
                }
            })
    }
    //    ------------------ Project closure----------------

    const AssignGeneralActivity = () => {
        service
            .ProjectClosure(projectId, projectStatusId, remarks, createdBy,token)
            .then((response) => {
                console.log(response);
                if (response.data.status === "200") {
                    swal("", response.data.message, "success")
                        .then(() => {
                            setTimeout(() => {
                                history.push("/ProjectClosure");
                            }, 0);
                        });

                }
            })
            .catch((error) => {
                console.error(error);
                swal("", "An error occurred during the transfer.", "error");
            });


    };
    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                        ProjectClosure View <span style={{ fontWeight: "normal" }}></span>
                                    </h3>

                                </div>
                            </div>
                            <div className="row filter-row" style={{ marginTop: "3%" }}>
                                <div className="col-sm-6 col-md-3">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Status <span className="text-danger">*</span></label>
                                        <div>
                                            <select style={{ backgroundColor: '#ffffff', color: '#000000' }} className="select" onChange={(e: any) => hanldeStatusType(e)}>
                                                <option value="" disabled selected> Select Options </option>
                                                {statusList.map((state: any) => (
                                                    <option key={state.id} value={state.id}>
                                                        {state.status}
                                                    </option>
                                                ))}
                                            </select>

                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-6 col-md-3">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }} >Reason<span className="text-danger">*</span></label>
                                        <div>
                                            <IonInput onIonChange={(e: any) => setRemarks(e.detail.value)} className="form-control datetimepicker" />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-6 col-md-3" style={{ display: "flex", alignSelf: "center", justifySelf: "center" }}>
                                    <a onClick={() => {
                                        // Empresources();
                                        AssignGeneralActivity();
                                    }} className="btn btn-orange btn-block w-100"> Submit </a>
                                </div>
                            </div>
                            {/* select with auto complete */}
                            {/* <div className="row filter-row" style={{ marginTop: "3%" }}>
                                <div className="col-md-3" >
                                    <div className="form-group">
                                        <label style={{ fontWeight: 'bold' }}>Employee Status <span className="text-danger">*</span></label>
                                        <div>
                                            <Select
                                                options={optionss}
                                                value={optionss.find((option: any) => option.value === status) || null}
                                                onChange={handlestatusChange}
                                                onInputChange={handleInputChange1}
                                                onMenuOpen={handleMenuOpen1}
                                                onMenuClose={handleMenuClose1}
                                                onFocus={handleFocus1}
                                                onBlur={handleBlur1}
                                                menuIsOpen={menuIsOpen1}
                                                isSearchable
                                                placeholder={<Placeholders />}
                                                components={{
                                                    DropdownIndicator: DropdownIndicators,
                                                }}
                                                className="custom-select3"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Reason<span className="text-danger">*</span></label>
                                            <div>
                                                <IonInput className="form-control datetimepicker" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>

                    </div>
                </div>
            </IonContent>
        </IonPage>
    );
};

export default ProjectClosureView;